import { steps } from '../../data/steps'
import { ref, computed } from 'vue'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export default {
  props: ['formData', 'formOptions', 'formLabels', 'data'],
  setup (props, ctx) {

    const goToStep = (stepId) => {
      ctx.emit('go-to-step', stepId)
    }

    const getFieldLabel = (stepId, fieldName) => {
      const step = steps.find(currentStep => currentStep.id === stepId)

      if (!step) {
        return null
      }

      return step.formLabels?.[fieldName] || null
    }

    const getFieldData = (stepId, fieldName) => {
      if (!props.data) {
        return null
      }

      const fieldData = props.data[stepId]?.[fieldName] || 'Keine Angabe'

      if (fieldName === 'birthday' && props.data[stepId]?.[fieldName]) {
        return dayjs(props.data[stepId]?.[fieldName]).format('DD.MM.YYYY')
      }

      if (fieldName === 'generalAdvertisingAccepted' && fieldData) {
        return (props.data[stepId]?.[fieldName]) ? 'Ja' : 'Nein'
      }

      return fieldData
    }

    return {
      goToStep,
      getFieldLabel,
      getFieldData
    }
  },
  template: `
    <div class="application__fields__list-group">
      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-1', 'salutation') }}</div>
        <div class="form__value">{{ getFieldData('step-1', 'salutation') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-1', 'gender') }}</div>
        <div class="form__value">{{ getFieldData('step-1', 'gender') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-1', 'firstname') }}</div>
        <div class="form__value">{{ getFieldData('step-1', 'firstname') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-1', 'lastname') }}</div>
        <div class="form__value">{{ getFieldData('step-1', 'lastname') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-1', 'birthday') }}</div>
        <div class="form__value">{{ getFieldData('step-1', 'birthday') }}</div> 
      </div>
    </div>
    
    <div class="application__fields__list-group">
      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-2', 'street') }}</div>
        <div class="form__value">{{ getFieldData('step-2', 'street') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-2', 'streetNumber') }}</div>
        <div class="form__value">{{ getFieldData('step-2', 'streetNumber') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-2', 'addressAddition') }}</div>
        <div class="form__value">{{ getFieldData('step-2', 'addressAddition') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-2', 'country') }}</div>
        <div class="form__value">{{ getFieldData('step-2', 'country') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-2', 'zip') }}</div>
        <div class="form__value">{{ getFieldData('step-2', 'zip') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-2', 'city') }}</div>
        <div class="form__value">{{ getFieldData('step-2', 'city') }}</div> 
      </div>
    </div>
    
    <div class="application__fields__list-group">
      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-3', 'email') }}</div>
        <div class="form__value">{{ getFieldData('step-3', 'email') }}</div> 
      </div>

      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-3', 'mobileNumber') }}</div>
        <div class="form__value">{{ getFieldData('step-3', 'mobileNumber') }}</div> 
      </div>
    </div>
    
    <div class="application__fields__list-group">
      <div>
        <div class="form__label">{{ getFieldLabel('step-4', 'occupation') }}</div>
        <div class="form__value">{{ getFieldData('step-4', 'occupation') }}</div> 
      </div>
    </div>
    
    <div class="application__fields__list-group">
      <div>
        <div class="form__label">{{ getFieldLabel('step-4-1', 'partTimeSelfEmployed') }}</div>
        <div class="form__value">{{ getFieldData('step-4-1', 'partTimeSelfEmployed') }}</div> 
      </div>
    </div>
    
    <div class="application__fields__list-group" v-if="getFieldData('step-4', 'occupation') === 'Ich mache etwas anderes.'">
      <div class="application__50">
        <div class="form__label">{{ getFieldLabel('step-4-2', 'occupationOther') }}</div>
        <div class="form__value">{{ getFieldData('step-4-2', 'occupationOther') }}</div> 
      </div>

      <div class="application__50" v-if="getFieldData('step-4-2', 'occupationOther') === 'Ich bin freiwillig versichert.'">
        <div class="form__label">{{ getFieldLabel('step-4-2', 'workingAs') }}</div>
        <div class="form__value">{{ getFieldData('step-4-2', 'workingAs') }}</div> 
      </div>
    </div>
    
    <div class="application__fields__list-group">
      <div>
        <div class="form__label">{{ getFieldLabel('step-5', 'includeFamily') }}</div>
        <div class="form__value">{{ getFieldData('step-5', 'includeFamily') }}</div> 
      </div>
    </div>
    
    <div class="application__fields__list-group">
      <div>
        <div class="form__label">{{ getFieldLabel('step-6', 'generalAdvertisingAccepted') }}</div>
        <div class="form__value">{{ getFieldData('step-6', 'generalAdvertisingAccepted') }}</div> 
      </div>
    </div>
    `
}